import { USER_TYPE } from "types";
import { VoucherCode } from "features/loyalty/voucher/types";

export interface SubscriptionTransaction {
	id: string;
	merchantId: number;
	updatedBy: string | null;
	quotation: number;
	status: SUBSCRIPTION_TRANSACTION_STATUS;
	total: number;
	originalPrice: number;
	note: string | null;
	method: PAYMENT_METHODS;
	createdAt: string;
	updatedAt: string;
	createdBy: {
		id: number;
		fullName: string;
	};
	createdByType: USER_TYPE;
	extraData: {
		package: PackageExtraData;
	};
	merchant?: {
		id: number;
		fullName: string;
		userType: string;
	};
	merchantSubscription?: {
		id: number;
		createdAt: string;
		updatedAt: string;
		merchantId: number;
		status: string;
		updatedBy: number | null;
		postedCar: number;
		postedHotSale: number;
		startDate: string;
		endDate: string;
		resetDate: string;
		quotation: number;
		subscriptionPackage: PackageExtraData;
	};
	files: FileItem[] | null;
	voucherCode?: VoucherCode;
}

interface PackageExtraData {
	id: number;
	name: {
		en: string;
		km: string;
		zh: string;
	};
	type: string;
	updatedBy: number;
	prices: {
		price: number;
		discount: number;
		quotation: number;
	};
	benefits: {
		code: string;
		type: string;
		hidden: boolean;
		unlimited: boolean;
	}[];
	commissions: {
		fee: number;
		percent: number;
	}[];
	annualMembership: number;
}

export enum PAYMENT_METHODS {
	CASH = "cash",
	BANK_TRANSFER = "bank_transfer",
	CARDS = "cards",
	ABAPAY = "abapay",
	ABAPAY_KHQR_DEEPLINK = "abapay_khqr_deeplink",
	ABAPAY_KHQR = "abapay_khqr",
	PAYWAY = "payway",
}

export enum SUBSCRIPTION_TRANSACTION_STATUS {
	new = "new",
	success = "success",
	failed = "failed",
}

export interface SubscriptionTransactionQueryParams {
	skip: number;
	take: number;
	merchantId?: number | string | null;
	id?: string;
	createdAtFrom?: string;
	createdAtTo?: string;
	status?: SUBSCRIPTION_TRANSACTION_STATUS | null;
	merchantName?: string;
}

export interface FileItem {
	path: string;
	name: string;
	url?: string;
	updatedBy:
		| number
		| {
				id: number;
				fullName: string;
		  };
	createdAt?: string;
}

export interface DataUpdate {
	note: string | null;
	files: FileItem[];
	status: SUBSCRIPTION_TRANSACTION_STATUS;
}
